import { ArticleHeading4, TooltipDesktop, UIHeading5, UIText2 } from '@cian/ui-kit';

import { FC, JSX } from 'react';

import { Link } from 'shared/components/InteractiveTypography';
import { WrapElementsSpacer } from 'shared/components/WrapElementsSpacer';

import { VasListProps } from './types';

import styles from './VASList.css';

export const VASList: FC<VasListProps> = props => {
  const { items, trackVasInfoClick } = props;

  const tooltipContentItems = Array.of<JSX.Element>();
  const vasIconItems = Array.of<JSX.Element>();

  for (const item of items) {
    if (item.tooltip) {
      tooltipContentItems.push(
        <li className={styles['tooltip-content-item']} key={item.id}>
          <WrapElementsSpacer horizontalSpace={4} verticalSpace={4} wrapItems={false}>
            <UIHeading5 color="warning_100">{item.tooltip.title}</UIHeading5>
          </WrapElementsSpacer>
          <UIText2 as="p">{item.tooltip.description}</UIText2>
        </li>,
      );
    }

    vasIconItems.push(
      <WrapElementsSpacer
        containerTestId="vas-list"
        horizontalSpace={4}
        itemTestId={`vas-item.${item.id}`}
        key={item.id}
        verticalSpace={4}
        wrapItems={false}
      >
        {!!item.title && (
          <UIText2 color="warning_100" fontWeight="700">
            {item.title}
          </UIText2>
        )}
      </WrapElementsSpacer>,
    );
  }

  if (!vasIconItems.length) {
    return null;
  }

  const contentView = (
    <WrapElementsSpacer horizontalSpace={4} verticalSpace={4}>
      {vasIconItems}
    </WrapElementsSpacer>
  );

  if (!tooltipContentItems.length) {
    return contentView;
  }

  return (
    <TooltipDesktop
      placement="top-end"
      theme="white"
      title={
        <>
          <ArticleHeading4>Действуют услуги</ArticleHeading4>
          <ul className={styles['tooltip-content-items-list']} data-testid="vas-tooltip-list">
            {tooltipContentItems}
          </ul>
          <Link
            behaviour="hover_primary_to_primary_hover"
            href="https://support.cian.ru/ru/knowledge_base/art/94/cat/19/"
            track={trackVasInfoClick}
          >
            Узнать подробнее
          </Link>
        </>
      }
    >
      <div className={styles['container']}>{contentView}</div>
    </TooltipDesktop>
  );
};
